import reducer from './reducers';

export { fetchFeatureFlags } from './actions';
export { featureEnabled } from './selectors';

export {
  FLAG_LIST_RECOVERY,
  FLAG_DRAWINGS,
  FLAG_LIST_FOLDERS,
  FLAG_HABITS_TAB,
  FLAG_APP_SPECIFIC_PASSWORD,
  FLAG_TASK_SETTINGS,
  FLAG_GOOGLE_BIRTHDAY_CALENDARS,
} from './constants';

export default reducer;
